// แคมเปญของแบรนด์ — ชื่อมาจาก Setting → Product → Campaigns
import type { Campaign } from "@contracts/api";
import { api } from "@shared/api/client";

export const campaignKeys = {
  byProduct: (product: string) => ["campaigns", product] as const,
};

export async function fetchCampaigns(product: string): Promise<Campaign[]> {
  const { data } = await api.get<Campaign[]>("/campaigns", { params: { product } });
  return Array.isArray(data) ? data : [];
}
